import { useState, useMemo, useEffect } from "react";
import { useSelector } from "react-redux";
import { selectUserState } from "../selectors/application";
import { sendResetPasswordLinkToEmail } from "../services/userService";
import { S_LANG, webStorage } from "../utils/webStorage";
import { isBizNull } from "../utils";
import { getVerificationMethods } from "../services/verificationService";

const useChangePhoneNumberModal = ({ fields, verifyEmailForm, selectVerificationMethodModal, checkUpdateRequired = () => {} }) => {
  /*Redux start*/
  const user = useSelector(selectUserState);
  /*Redux end*/
  const lang = webStorage.get(S_LANG);
  const { phoneAreaLabel, phoneAreaInfoMessage, phoneLabel, phoneInfoMessage, phoneMissingMessage, phoneWarningMessage, disclamerChangePhone, updateSuccessMessage, updateFailedMessage, resetPassword, ctaEditPhoneNumber } = fields || {};
  const { ctaName, colorScheme, iconName } = ctaEditPhoneNumber?.fields || {};
  const [phoneArea, setPhoneArea] = useState(user?.mobileNoCountryCode);
  const [phoneNumber, setPhoneNumber] = useState(user?.mobileNo);
  const [phoneIsValid, setPhoneIsValid] = useState(true);
  const [submitTimestamp, setSubmitTimestamp] = useState();

  const [verificationMethodModalOpened, setVerificationMethodModalOpened] = useState(false);
  const [verificationMethod, setVerificationMethod] = useState(null);
  const [verifyMethodSuccess, setVerifyMethodSuccess] = useState(false);

  const [serverError, setServerError] = useState(null);
  const [updatedMessage, setUpdatedMessage] = useState(null);
  const [changePhoneNumberOpened, setChangePhoneNumberOpened] = useState(false);
  const [resetPasswordOpened, setResetPasswordOpened] = useState(false);
  const needUpdate = useMemo(() => {
    console.log(phoneArea !== user?.mobileNoCountryCode || phoneNumber !== user?.mobileNo);
    return phoneArea !== user?.mobileNoCountryCode || phoneNumber !== user?.mobileNo;
  }, [phoneArea, phoneNumber, user]);
  useEffect(() => {
    checkUpdateRequired && checkUpdateRequired({ phoneArea, phoneNumber, needUpdate });
  }, [needUpdate]);

  const onPhoneChange = (area, number, isValid) => {
    setPhoneNumber(number);
    setPhoneArea(area);
    setPhoneIsValid(isValid);
  };

  const validatePhoneFields = () => {
    let valid = true;
    if (isBizNull(phoneArea)) {
      valid = false;
    }
    if (isBizNull(phoneNumber)) {
      valid = false;
    }
    return valid;
  };

  const phoneProps = {
    phoneArea: {
      label: phoneAreaLabel?.value,
      value: user?.mobileNoCountryCode,
      infoMessage: phoneAreaInfoMessage?.value
    },
    phoneNumber: {
      label: phoneLabel?.value,
      value: user?.mobileNo,
      infoMessage: phoneInfoMessage?.value
    },
    warningMessage: phoneWarningMessage.value,
    missingMessage: phoneMissingMessage.value,
    onChange: (area, number, isValid) => {
      onPhoneChange(area, number, isValid);
    },
    onInit: (area, number, isValid) => {
      onPhoneChange(area, number, isValid);
    },
    submitTimestamp: submitTimestamp
  };
  const hideResetPassword = evt => {
    setResetPasswordOpened(false);
  };
  const onSubmitPhoneNumberChange = async evt => {
    setSubmitTimestamp(new Date());
    let valid = true;
    if (!phoneIsValid) {
      valid = false;
    }
    if (valid) {
      setVerificationMethodModalOpened(true);
    }
  };
  const changePhoneNumberModalProps = {
    open: changePhoneNumberOpened,
    phoneAreaEntered: phoneArea,
    phoneNumberEntered: phoneNumber,
    fields,
    onForgetPassword() {
      setChangePhoneNumberOpened(false);
      setResetPasswordOpened(true);
    },
    onCloseClicked: evt => {
      setChangePhoneNumberOpened(false);
    },
    onUpdateSuccess: evt => {
      setChangePhoneNumberOpened(false);
      setUpdatedMessage(updateSuccessMessage?.value);
    }
  };
  const resetPasswordProps = {
    open: resetPasswordOpened,
    onCloseClicked: hideResetPassword,
    isInConfirmationStep: false,
    sendResetPasswordLink: async (evt, data) => {
      await sendResetPasswordLinkToEmail(lang, data.email);
    },
    ...resetPassword
  };
  const ctaChangePhoneNumber = ctaEditPhoneNumber && {
    buttonText: ctaName?.value,
    colorScheme: colorScheme,
    iconName: iconName,
    isDisabled: !needUpdate,
    callback: evt => onSubmitPhoneNumberChange(evt)
  };
  // SELECT VERIFICATION MODAL DATA
  const verificationMethods = getVerificationMethods(user);
  const hideVerificationMethodModal = () => {
    setVerificationMethodModalOpened(false);
    setVerificationMethod(false);
    setVerifyMethodSuccess(false);
  };
  const verificationModalProps = {
    setUpdatedPhoneMessage: setUpdatedMessage,
    fields,
    user,
    verificationMethods,
    verificationMethod,
    setVerificationMethod,
    verifyMethodSuccess,
    setVerifyMethodSuccess,
    open: verificationMethodModalOpened,
    onCloseClicked: hideVerificationMethodModal,
    phoneAreaEntered: phoneArea,
    phoneNumberEntered: phoneNumber,
    verifyEmailForm,
    selectVerificationMethodModal
  };
  // END SELECT VERIFICATION MODAL DATA

  return {
    needUpdate,
    phoneProps,
    validatePhoneFields,
    ctaChangePhoneNumber,
    changePhoneNumberModalProps,
    resetPasswordProps,
    serverError,
    updatedMessage,
    disclamerChangePhone,
    verificationModalProps,
    user
  };
};
export default useChangePhoneNumberModal;
